import React, { useEffect, useMemo, useState } from 'react';
import { Grid, Box, Typography, Divider, Skeleton } from '@mui/material';
import { HighChartDonutChart, AreaChart } from '../../../shared';
import { TRIGGER_ENGAGEMENT_CHART_OPTIONS, CREATIVE_NAME_CHART_OPTIONS } from './constants';
import { useSelector } from 'react-redux';

const TriggerEngagement = () => {
    const { company } = useSelector((state) => state.company);
    const [areaData, setAreaData] = useState([
        {
            name: 'Trigger Count',
            data: []
        }
    ]);
    const engagementRateTitles ={
        66: 'Engagement Rate',
        161: 'Engagement Rate',
        default: 'Trigger Engagement Rate'
    };
    const areaChartTitles ={
        66: 'Audience Count',
        161: 'Audience Count',
        default: 'Trigger Count'
    };
    
    const areaChartYaxis ={
        64: 'Count',
        66: 'Count',
        161: 'Count',
        default: 'Trigger Count'
    };
    const {
        triggerSummary: {
            engagement, creative, isTriggerSummaryGraphsLoading 
        } 
    } = useSelector((state => state.trigger));

    const areaChartOptions = useMemo(() => ({
        ...CREATIVE_NAME_CHART_OPTIONS,
        yaxis: {
            ...CREATIVE_NAME_CHART_OPTIONS.yaxis,
            title: {
                ...CREATIVE_NAME_CHART_OPTIONS.yaxis.title,
                text: areaChartYaxis[company.id] || areaChartYaxis.default
            }
        }
    }), [company.id]);
    useEffect(() => {
        setAreaData([{
            ...creative[0],
            name: areaChartYaxis[company.id] || areaChartYaxis.default
        }]);
    }, [creative]);
    
    return (
        <Grid item xs={12}>
            <Grid container spacing={'24px'}>
                {/* Trigger Engagement */}
                <Grid item className="custom-grid-item" xs={4}>
                    <Box className="custom-paper bg-gray-50 padding-24px br-16px min-height-388px" sx={{ maxWidth: '350px' }}>
                        <Box className="flex-row-space-between">
                            <Box>
                                <Typography className="text-md-medium gray-900">
                                    {engagementRateTitles[company.id] || engagementRateTitles.default}
                                </Typography>
                            </Box>
                        </Box>
                        {/* HighChartDonutChart */}
                        {isTriggerSummaryGraphsLoading ? (
                            <Box className="box-sizing-border-box pt-20px">
                                <Skeleton
                                    animation="pulse"
                                    height={250}
                                    variant="circular"
                                    width={250}
                                />
                            </Box>
                        ) : (
                            <HighChartDonutChart
                                chartOptions={TRIGGER_ENGAGEMENT_CHART_OPTIONS}
                                seriesData={engagement}
                            />
                        )}
                    </Box>
                </Grid>

                {/* Trigger Count */}
                <Grid item className="custom-grid-item" xs={8}>
                    <Box className="custom-paper bg-white br-16px border-1-gray min-height-388px height-100">
                        <Box className="padding-tb-24-rl-20">
                            <Typography className="text-md-medium gray-900">
                                {areaChartTitles[company.id] || areaChartTitles.default}
                            </Typography>
                        </Box>
                        <Divider className="border-1-gray" />
                        <Box
                            className="padding-24px min-height-320px"
                            sx={{ height: 'calc(100% - 73px)' }}
                        >
                            {/* Area Chart */}
                            {isTriggerSummaryGraphsLoading ? (
                                <Skeleton
                                    animation="wave"
                                    height={320}
                                    variant="rounded"
                                    width={600}
                                />
                            ) : (
                                <AreaChart
                                    chartOptions={areaChartOptions}
                                    chartSeries={areaData}
                                />
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TriggerEngagement;
